/* eslint-disable */
import React, { Component } from 'react';
import styled from 'styled-components';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import ErrorMessage from './ErrorMessage';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

    this.datePicker = React.createRef();
  }
  focus = (e) => {
    const modal = document.getElementsByClassName('react-datepicker-popper')[0];
    if (!modal || (modal && !modal.contains(e.target))) this.datePicker.current.setOpen(true);
  }

  render() {
    const {
      selected,
      onSelect,
      onChange,
      errorMessage,
      placeHolder,
      name,
    } = this.props;
    const red = '#ff5c6c';
    const blue = '#384076';
    const grey = '#E2E5EF';

    const display = 'block';
    const marginTop = '20px';

    return (
      <Container
        style={this.props.style || {}}
        onClick={this.focus}
        color={errorMessage ? red : blue}
        borderColor={errorMessage ? red : grey}
      >
        <div style={{ marginBottom: 8 }}>
          <label htmlFor={name} style={{ display, marginBottom: 5 }}>{placeHolder}</label>
        </div>
        <div>
          <DatePicker
            ref={this.datePicker}
            selected={selected}
            onSelect={onSelect}
            onChange={onChange}
            showTimeSelect
            dateFormat="E d MMM, h:mm a"
          />
        </div>
        {errorMessage ? (<ErrorMessage message={errorMessage} />) : null}
      </Container>
    );
  }
}

const Container = styled.div`
  height: 50px;
  border: ${props => `2px solid ${props.borderColor};`}
  border-radius: 0.25em;
  padding: 0.7em 1em;
  margin-bottom: 20px;
  width: 100%;

  input {
    font-size: 22px;
    width: 425px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    color: ${props => `${props.color};`}

    &::placeholder {
      opacity: 1;
      color: #a1aeb7;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
    color: #9da1bb;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/shared/LabelledDatePicker.js